import { Section } from 'app/library/section/models/section.model';
import { IEntity } from 'app/projects/entity/src/lib/interfaces/entity.interface';
import { User } from 'app/projects/user/src/lib/models/user';

export interface SectionStats {
    section: Section;
    completed: boolean;
}

export class UserSectionStats implements IEntity {
    static props_to_search = ['user', 'firstName', 'lastName', 'sectionStats', 'section', 'name'];

    sectionStats: SectionStats[] = [];
    id: string;

    constructor(public user: User, public completed: number, public total: number) {
        this.id = user.id;
    }
}
